import React, { useEffect } from 'react';
import { X, Phone } from 'lucide-react';

export const DemoModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[99998] flex items-center justify-center p-5 transition-opacity duration-300 ${
        isOpen ? 'opacity-100' : 'opacity-0'
      }`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`bg-white rounded-3xl p-10 max-w-[420px] w-full relative shadow-2xl transition-all duration-300 ${
          isOpen ? 'scale-100 translate-y-0' : 'scale-90 translate-y-5'
        }`}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
          className="absolute top-4 right-4 w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 hover:text-gray-800 transition-colors duration-200 z-50 cursor-pointer"
          aria-label="Close modal"
          id="waypointDemoClose"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex justify-center mb-4">
          <img
            src="https://customer-assets.emergentagent.com/job_northfield-modern/artifacts/hv4kgxab_logo-horizontal-0KNiObeI.svg"
            alt="Waypoint"
            className="max-w-[200px] h-auto"
          />
        </div>

        <h2 className="text-center text-3xl font-bold text-gray-800 mb-3">
          Draft Demo
        </h2>

        <p className="text-center text-gray-600 text-base leading-relaxed mb-7">
          This is a draft landing page for <strong className="text-[#231F20] font-semibold">Northfield Community LDC</strong>, developed by <strong className="text-[#30225A] font-semibold">Waypoint</strong>.
        </p>

        <div className="flex flex-col gap-3">
          <a
            href="tel:+1-646-397-0468"
            className="flex items-center justify-center gap-2.5 px-6 py-4 rounded-full bg-[#231F20] hover:bg-[#231F20]/90 text-white font-semibold text-base transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl"
          >
            <Phone className="w-5 h-5" />
            Call Us
          </a>
        </div>

        <div className="text-center mt-4">
          <a
            href="https://waypoint.agency/contact/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-gray-600 hover:text-[#231F20] text-sm font-medium transition-colors duration-200 hover:underline"
          >
            or contact us online
          </a>
        </div>
      </div>
    </div>
  );
};